import { Accordion } from '@squareup/dex-ui';
import { Box } from '@squareup/dex-ui-shared-base';
import React, { FC, PropsWithChildren } from 'react';

interface MdxAccordionProps {
  title?: string;
}

const MdxAccordion: FC<PropsWithChildren<MdxAccordionProps>> = ({
  title,
  children,
}) => {
  return (
    <Accordion
      title={title || ''}
      defaultExpanded={false}
      trackingId="mdx-accordion-clicked"
      padding={{ vertical: '2x' }}
    >
      {children}
    </Accordion>
  );
};

MdxAccordion.displayName = 'MdxAccordion';

const MdxAccordionGroup: FC<PropsWithChildren> = ({ children }) => {
  return <Box>{children}</Box>;
};

MdxAccordionGroup.displayName = 'MdxAccordionGroup';

export { MdxAccordion, MdxAccordionGroup };
